<div [class.rtl]="currLang == 'ar'" [class.ltr]="currLang == 'en'" class="modal" tabindex="-1" role="dialog"
  id="addGradeModal" style="direction: ltr;" data-backdrop="static" data-keyboard="false">
  <div class="modal-dialog">
    <div class="modal-content" [ngStyle]="{'direction' : currLang == 'en' ? 'ltr' : 'rtl'}">
      <div class="modal-header">
        <h5 class="modal-title">{{state}} {{'grades-classes.add-grade-modal.grade' | translate}}</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <form [formGroup]="addGradeForm" [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
          <label class="section-header">{{'grades-classes.add-grade-modal.grade-info' | translate}}</label>
          <div class="row">
            <div class="col-lg-6">
              <mat-form-field appearance="outline" dir="ltr">
                <mat-label>{{'grades-classes.add-grade-modal.grade-name' | translate}}</mat-label>
                <input matInput formControlName="name">
                <mat-error>{{getGradeFormValidation('name')}}</mat-error>
              </mat-form-field>
              <mat-form-field appearance="outline" dir="ltr">
                <mat-label>{{'grades-classes.add-grade-modal.assigned-gate' | translate}}</mat-label>
                <mat-select formControlName="gates_ids">
                  <mat-option>
                    <ngx-mat-select-search [formControl]="gateSearch.filterCtrl"
                      [placeholderLabel]="gateSearch.placeholderKey | translate"
                      [noEntriesFoundLabel]="gateSearch.noResultsKey | translate">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let gate of gateSearch.filtered$ | async" [value]="gate.id">{{gate.name}}</mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-lg-5">
              <mat-form-field appearance="outline" dir="ltr">
                <mat-label>{{'grades-classes.add-grade-modal.assigned-supervisors' | translate}}</mat-label>
                <mat-select formControlName="supervisors_ids" multiple>
                  <mat-option>
                    <ngx-mat-select-search [formControl]="supervisorSearch.filterCtrl"
                      [placeholderLabel]="supervisorSearch.placeholderKey | translate"
                      [noEntriesFoundLabel]="supervisorSearch.noResultsKey | translate">
                    </ngx-mat-select-search>
                  </mat-option>
                  <mat-option *ngFor="let supervisor of supervisorSearch.filtered$ | async" [value]="supervisor.id">{{supervisor.name}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <!-- <div class="self-checkout">
                <mat-form-field appearance="outline" dir="ltr">
                  <mat-label>{{'grades-classes.add-grade-modal.self-checkout.title' | translate}}</mat-label>
                  <mat-select formControlName="students_can_self_checkout">
                    <mat-option [value]="true">{{'grades-classes.add-grade-modal.self-checkout.true' |
                      translate}}</mat-option>
                    <mat-option [value]="false">{{'grades-classes.add-grade-modal.self-checkout.false' |
                      translate}}</mat-option>
                  </mat-select>
                </mat-form-field>
                <span triggers="manual" #s="ngbTooltip" placement="bottom" tooltipClass="my-custom-class"
                  [ngbTooltip]="selfInfoTemplate" style="float: right; margin-inline-start: 9px;" (mouseover)="s.open()"
                  (mouseout)="s.close()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 18 18">
                    <g id="Group_5174" data-name="Group 5174" transform="translate(-1172 -224)">
                      <g id="Ellipse_652" data-name="Ellipse 652" transform="translate(1172 224)" fill="none"
                        stroke="#1D71D3" stroke-width="1">
                        <circle cx="9" cy="9" r="9" stroke="none" />
                        <circle cx="9" cy="9" r="8.5" fill="none" />
                      </g>
                      <path id="Path_5462" data-name="Path 5462"
                        d="M2.864-7.1v5.537A3.88,3.88,0,0,0,2.92-.8a.7.7,0,0,0,.185.382.536.536,0,0,0,.326.135q.2.017.477.017V0H.562V-.27A2.443,2.443,0,0,0,1.117-.32a.553.553,0,0,0,.32-.2.786.786,0,0,0,.14-.4,6.051,6.051,0,0,0,.028-.646v-2.65q0-.651-.022-1.033A2.649,2.649,0,0,0,1.5-5.812a.356.356,0,0,0-.163-.236A.645.645,0,0,0,1.067-6.1a.992.992,0,0,0-.23.028,2.683,2.683,0,0,0-.275.084l-.112-.27L2.527-7.1Zm-.629-3.6a.739.739,0,0,1,.545.219A.739.739,0,0,1,3-9.939.745.745,0,0,1,2.78-9.4a.73.73,0,0,1-.545.225A.73.73,0,0,1,1.69-9.4a.745.745,0,0,1-.219-.539.739.739,0,0,1,.219-.545A.739.739,0,0,1,2.235-10.7Z"
                        transform="translate(1178.551 237.703)" fill="#1D71D3" />
                    </g>
                  </svg>
                </span>
                <ng-template #selfInfoTemplate>
                  <div class="self-info-container">
                    <div>{{'grades-classes.add-grade-modal.self-checkout.info-msg' | translate}}</div>
                  </div>
                </ng-template>
              </div> -->
            </div>
          </div>
          <!-- Class Section-->
          <label class="section-header">{{'grades-classes.add-grade-modal.create-class' | translate}}</label>
          <div class="row classes-teachers-section">
            <ng-container *ngFor="let clazz of classes_names.controls;index as idx">
              <ng-container formArrayName="classes_names">
                <div class="col-lg-6">
                  <mat-form-field appearance="outline" dir="ltr">
                    <mat-label>{{'grades-classes.add-grade-modal.class-name' | translate}}</mat-label>
                    <input matInput [formControlName]="idx">
                    <mat-error>{{getClassValidation(classes_names.controls[idx])}}</mat-error>
                  </mat-form-field>
                </div>
              </ng-container>
              <ng-container formArrayName="teachers_ids">
                <div class="col-lg-5">
                  <div class="d-flex">
                    <mat-form-field appearance="outline" dir="ltr">
                      <mat-label>{{'grades-classes.add-grade-modal.assigned-teachers' | translate}}</mat-label>
                      <mat-select [formControlName]="idx" multiple>
                        <mat-option>
                          <ngx-mat-select-search [formControl]="teacherSearch.filterCtrl"
                            [placeholderLabel]="teacherSearch.placeholderKey | translate"
                            [noEntriesFoundLabel]="teacherSearch.noResultsKey | translate">
                          </ngx-mat-select-search>
                        </mat-option>
                        <mat-option *ngFor="let teacher of teacherSearch.filtered$ | async" [value]="teacher.id">{{teacher.name}}</mat-option>
                      </mat-select>
                      <!-- <mat-error>teacher Is Required</mat-error> -->
                    </mat-form-field>
                    <svg (click)="removeClassTeacherRow(idx)" *ngIf="formFlag==='edit'"
                      [class]="schoolClasses[idx]?.students.length > 0 ? 'bin-icon dimmed':'bin-icon'"
                      xmlns="http://www.w3.org/2000/svg" width="21.102" height="25.982" viewBox="0 0 21.102 25.982">
                      <g id="bin_1_" data-name="bin (1)" transform="translate(0.003 0.001)">
                        <path id="Path_5376" data-name="Path 5376"
                          d="M223.006,154.7a.608.608,0,0,0-.608.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,223.006,154.7Zm0,0"
                          transform="translate(-208.869 -145.291)" fill="#707070" />
                        <path id="Path_5377" data-name="Path 5377"
                          d="M105.006,154.7a.608.608,0,0,0-.608.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,105.006,154.7Zm0,0"
                          transform="translate(-98.049 -145.291)" fill="#707070" />
                        <path id="Path_5378" data-name="Path 5378"
                          d="M1.725,7.734V22.725a3.357,3.357,0,0,0,.893,2.315,3,3,0,0,0,2.174.94H16.3a3,3,0,0,0,2.174-.94,3.357,3.357,0,0,0,.893-2.315V7.734a2.324,2.324,0,0,0-.6-4.571H15.659V2.4A2.39,2.39,0,0,0,13.249,0h-5.4a2.39,2.39,0,0,0-2.41,2.4v.761H2.321a2.324,2.324,0,0,0-.6,4.571ZM16.3,24.763H4.791a1.927,1.927,0,0,1-1.85-2.038V7.787H18.154V22.725a1.927,1.927,0,0,1-1.85,2.038ZM6.653,2.4A1.172,1.172,0,0,1,7.846,1.216h5.4A1.172,1.172,0,0,1,14.442,2.4v.761H6.653ZM2.321,4.38H18.774a1.1,1.1,0,0,1,0,2.19H2.321a1.1,1.1,0,0,1,0-2.19Zm0,0"
                          transform="translate(0 0)" fill="#707070" />
                        <path id="Path_5379" data-name="Path 5379"
                          d="M164.007,154.7a.608.608,0,0,0-.609.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,164.007,154.7Zm0,0"
                          transform="translate(-153.459 -145.291)" fill="#707070" />
                      </g>
                    </svg>
                    <svg (click)="removeClassTeacherRow(idx)" *ngIf="formFlag!=='edit'" class="bin-icon"
                      xmlns="http://www.w3.org/2000/svg" width="21.102" height="25.982" viewBox="0 0 21.102 25.982">
                      <g id="bin_1_" data-name="bin (1)" transform="translate(0.003 0.001)">
                        <path id="Path_5376" data-name="Path 5376"
                          d="M223.006,154.7a.608.608,0,0,0-.608.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,223.006,154.7Zm0,0"
                          transform="translate(-208.869 -145.291)" fill="#707070" />
                        <path id="Path_5377" data-name="Path 5377"
                          d="M105.006,154.7a.608.608,0,0,0-.608.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,105.006,154.7Zm0,0"
                          transform="translate(-98.049 -145.291)" fill="#707070" />
                        <path id="Path_5378" data-name="Path 5378"
                          d="M1.725,7.734V22.725a3.357,3.357,0,0,0,.893,2.315,3,3,0,0,0,2.174.94H16.3a3,3,0,0,0,2.174-.94,3.357,3.357,0,0,0,.893-2.315V7.734a2.324,2.324,0,0,0-.6-4.571H15.659V2.4A2.39,2.39,0,0,0,13.249,0h-5.4a2.39,2.39,0,0,0-2.41,2.4v.761H2.321a2.324,2.324,0,0,0-.6,4.571ZM16.3,24.763H4.791a1.927,1.927,0,0,1-1.85-2.038V7.787H18.154V22.725a1.927,1.927,0,0,1-1.85,2.038ZM6.653,2.4A1.172,1.172,0,0,1,7.846,1.216h5.4A1.172,1.172,0,0,1,14.442,2.4v.761H6.653ZM2.321,4.38H18.774a1.1,1.1,0,0,1,0,2.19H2.321a1.1,1.1,0,0,1,0-2.19Zm0,0"
                          transform="translate(0 0)" fill="#707070" />
                        <path id="Path_5379" data-name="Path 5379"
                          d="M164.007,154.7a.608.608,0,0,0-.609.608v11.5a.608.608,0,1,0,1.217,0v-11.5A.608.608,0,0,0,164.007,154.7Zm0,0"
                          transform="translate(-153.459 -145.291)" fill="#707070" />
                      </g>
                    </svg>
                  </div>
                </div>
                <span>
                </span>
              </ng-container>
            </ng-container>
          </div>
          <svg class="add-btn" (click)="addClassTeacherRow()" xmlns="http://www.w3.org/2000/svg" width="32" height="32"
            viewBox="0 0 32 32"
            [ngStyle]="{'left': currLang == 'en' ? '55.5rem' :'auto','right': currLang == 'ar' ? '55.5rem' :'auto'}">
            <g id="Group_5483" data-name="Group 5483" transform="translate(-838.393 -518.393)">
              <g id="Group_1842" data-name="Group 1842" transform="translate(846.196 526.196)">
                <g id="Group_1841" data-name="Group 1841">
                  <path id="Path_5042" data-name="Path 5042"
                    d="M336.219,328.273h-4.6v-4.6a1.673,1.673,0,0,0-3.346,0v4.6h-4.6a1.673,1.673,0,0,0,0,3.346h4.6v4.6a1.673,1.673,0,1,0,3.346,0v-4.6h4.6a1.673,1.673,0,1,0,0-3.346Z"
                    transform="translate(-322 -322)" fill="#707070" stroke="#fafafa" stroke-width="0.25" />
                </g>
              </g>
              <g id="Ellipse_652" data-name="Ellipse 652" transform="translate(838.393 518.393)" fill="none"
                stroke="#707070" stroke-width="1">
                <circle cx="16" cy="16" r="16" stroke="none" />
                <circle cx="16" cy="16" r="15.5" fill="none" />
              </g>
            </g>
          </svg>

          <!-- Dismissal time section (view only) -->
          <div class="dismissal-times">
            <div class="dismissal-times--pickup-info">
              <label class="section-header">{{'grades-classes.add-grade-modal.pickup-info' | translate}}</label>
            </div>
            <!-- Dismissal times alert -->
            <div class="dismissal-alert" *ngIf="showDismissalAlert">
              <div class="dismissal-alert--content">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="9" stroke="#1D71D3" stroke-width="1.5" fill="none"/>
                  <text x="10" y="14.5" text-anchor="middle" fill="#1D71D3" font-size="12" font-weight="bold" font-family="sans-serif">i</text>
                </svg>
                <span>{{'grades-classes.add-grade-modal.dismissal-alert' | translate}}</span>
              </div>
              <span class="dismissal-alert--close" (click)="showDismissalAlert = false">&times;</span>
            </div>
            <div class="dismissal-times--body">
              <div class="toggle-flags row">
                <div class="col-lg-6">
                  <div class="multible-days-flag">
                    <span class="flag-title">{{'grades-classes.add-grade-modal.special-time' | translate}}</span>
                    <div class="flag-desc">{{'grades-classes.add-grade-modal.special-time-desc' | translate}}</div>
                  </div>
                </div>
                <div class="col-lg-5">
                  <div class="buffer-flag">
                    <span class="flag-title">{{'grades-classes.add-grade-modal.buffer-time-toggle' | translate}}</span>
                    <div class="flag-desc">{{'grades-classes.add-grade-modal.buffer-time-desc' | translate}}</div>
                  </div>
                </div>
              </div>
              <div class="dismissal-times--body--fields">
                <!-- single Time-->
                <div class="row mb-3" *ngIf="!is_special_time_enabled ">
                  <div class="col-lg-6">
                    <mat-form-field class="startTimeMulti" appearance="outline" dir="ltr">
                      <mat-label>{{'grades-classes.add-grade-modal.special-time-label'|translate}}</mat-label>
                      <input id="SingleInput" matInput type="time" [(ngModel)]="singleTime"
                        [ngModelOptions]="{standalone: true}" disabled />
                    </mat-form-field>
                  </div>
                  <div class="col-lg-5" *ngIf="is_start_time_buffer_enabled">
                    <mat-form-field class="startTimeMulti" appearance="outline" dir="ltr">
                      <mat-label>{{'grades-classes.add-grade-modal.buffer-time-label'|translate}}</mat-label>
                      <input id="SingleBufferInput" class="buffer-input" matInput type="number"
                        [(ngModel)]="singleBufferTime" [ngModelOptions]="{standalone: true}" disabled />
                      <span matTextSuffix
                        class="buffer-suffix">{{'grades-classes.add-grade-modal.buffer-time-mins'|translate}}</span>
                    </mat-form-field>
                  </div>
                </div>

                <!--multible Times-->
                <div class="row" *ngIf="is_special_time_enabled ">
                  <div class="col-lg-12" *ngFor="let day of daysOfWeak; index as i">
                    <div class="row">
                      <div class="col-lg-6">
                        <mat-form-field class="startTimeMulti" appearance="outline" dir="ltr">
                          <mat-label>{{day.name|translate}}</mat-label>
                          <input [id]="day.input" matInput type="time"
                            [(ngModel)]="day.time" [ngModelOptions]="{standalone: true}"
                            readonly disabled />
                        </mat-form-field>
                      </div>

                      <div class="col-lg-4" *ngIf="is_start_time_buffer_enabled">
                        <mat-form-field class="startTimeMulti" appearance="outline" dir="ltr">
                          <mat-label>{{'grades-classes.add-grade-modal.buffer-time-label'|translate}}</mat-label>
                          <input [id]="day.buffer_input" class="buffer-input" matInput type="number"
                            [(ngModel)]="day.buffer_time" [ngModelOptions]="{standalone: true}"
                            readonly disabled />
                          <span matTextSuffix
                            class="buffer-suffix">{{'grades-classes.add-grade-modal.buffer-time-mins'|translate}}</span>
                        </mat-form-field>
                      </div>
                      <div class="col-lg-2">
                        <div class="off-container day-status-label">
                          <span class="px-1"> {{day.is_closed ? ('grades-classes.add-grade-modal.special-time-off' |
                            translate ):('grades-classes.add-grade-modal.special-time-on' | translate)}}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer">
        <button [disabled]="addGradeForm.invalid || invalidFormFlag || single_time_error || errorsFlag"
          (click)="showNotifyParentModal()" type="button"
          class="btn btn-primary save">{{'grades-classes.add-grade-modal.save' | translate}}</button>
        <div class="error-alert" *ngIf="single_time_error || errorsFlag">
          {{'grades-classes.add-grade-modal.error-alert' | translate}}
        </div>
      </div>
    </div>
  </div>
  <div class="back-drop" *ngIf="showNotificationModal">
    <div class="modal-container">
      <div class="modal-head">
        <span style="cursor: pointer;" (click)="closeModal()">X</span>
      </div>
      <div class="modal-bady">
        <div class="title" [class.title-ar]="currLang == 'ar'"
          [ngStyle]="{'text-align': currLang == 'en' ? 'left' :'right'}">
          {{"grades-classes.add-grade-modal.notify-parent-modal.title" | translate }} </div>
        <div class="desc">
          {{"grades-classes.add-grade-modal.notify-parent-modal.description" | translate }}
        </div>
      </div>
      <div class="modal-footar">
        <button class="btn btn-light" style="border:1px solid #D0D5DD; background-color: white;"
          (click)="saveGrade(false)">
          {{"grades-classes.add-grade-modal.notify-parent-modal.dont-notify" | translate }} </button>
        <button class="btn btn-primary" style="background:#0074EC;" (click)="saveGrade(true)">
          {{"grades-classes.add-grade-modal.notify-parent-modal.notify" | translate }} </button>
      </div>
    </div>
  </div>
</div>
<app-error-msg></app-error-msg>